import { render, staticRenderFns } from "./gridAttributeSetting.vue?vue&type=template&id=824968f6&scoped=true&"
import script from "./gridAttributeSetting.vue?vue&type=script&lang=js&"
export * from "./gridAttributeSetting.vue?vue&type=script&lang=js&"
import style0 from "./gridAttributeSetting.vue?vue&type=style&index=0&id=824968f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824968f6",
  null
  
)

export default component.exports